var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.167969,
    width: 160,
    height: 160,
    rx: 7,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 56,
    width: 60,
    height: 61
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 56.168,
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 98.168C64.9 98.168 63.9583 97.7763 63.175 96.993C62.3917 96.2096 62 95.268 62 94.168V66.168C62 65.068 62.3917 64.1263 63.175 63.343C63.9583 62.5596 64.9 62.168 66 62.168H82V66.168H66V94.168H94V78.168H98V94.168C98 95.268 97.6083 96.2096 96.825 96.993C96.0417 97.7763 95.1 98.168 94 98.168H66ZM68 90.168H92L84.5 80.168L78.5 88.168L74 82.168L68 90.168ZM90 74.168V70.168H86V66.168H90V62.168H94V66.168H98V70.168H94V74.168H90Z",
    fill: "#4D4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/errorImage.d0f5423506abdffe54577f809057dbfe.svg";
export { ForwardRef as ReactComponent };